export default __webpack_public_path__ + "static/media/wippy_download_page_google_text.9a8322ea.svg";